export {
	fullLocaleMap,
	fullLocalesArray,
	languages,
	languagesAsArray,
} from './model/names';
export { useLanguage } from './model/useLanguage';
